export default (api) => ({
  totals: (endpoint) => api.$get(endpoint),

  evolution: (baseUrl, range) => api.$get(`${baseUrl}stats/evolution/${range}`),

  deploymentsCount: (params) => api.$get("stats/deployments/count", { params }),

  agentsCount: (baseUrl, params) => api.$get(`${baseUrl}stats/agents/count`, { params }),

  alertsCount: (baseUrl, params) => api.$get(`${baseUrl}stats/alerts/count`, { params }),

  news: (baseUrl) => api.$get(`${baseUrl}stats/news`),

  lastAlerts: (baseUrl, params) => api.$get(`${baseUrl}alerts`, { params }),

  patchAlert: (id, status) => api.$patch(`alerts/${id}`, { status }),
});
